import { Injectable } from '@angular/core';
import { Pagination } from '../../models/pagination.interface';

@Injectable({
  providedIn: 'root',
})
export class LibPaginationService {
  constructor() {}
  getPager(totalItems: number, currentPage: number = 1, pageSize: number = 1): Pagination {
    // calculate total pages
    let totalPages = Math.ceil(totalItems / pageSize);

    // ensure current page isn't out of range
    if (currentPage < 1) {
      currentPage = 1;
    } else if (currentPage > totalPages) {
      currentPage = totalPages;
    }

    let startPage: number, endPage: number;
    if (totalPages <= 4) {
      // less than 4 total pages so show all
      startPage = 1;
      endPage = totalPages;
    } else {
      // more than 4 total pages so calculate start and end pages
      if (currentPage <= 2) {
        startPage = 1;
        endPage = 4;
      } else if (currentPage + 3 >= totalPages) {
        startPage = totalPages - 3;
        endPage = totalPages;
      } else {
        startPage = currentPage - 1;
        endPage = currentPage + 2;
      }
    }

    // calculate start and end item indexes
    let startIndex = (currentPage - 1) * pageSize;
    let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

    // create an array of pages to ng-repeat in the pager control
    let pages = Array.from(Array(endPage + 1 - startPage).keys()).map((i) => startPage + i);

    // return object with all pager properties required by the view
    return {
      totalItems: totalItems,
      currentPage: currentPage,
      pageSize: pageSize,
      totalPages: totalPages,
      startPage: startPage,
      endPage: endPage,
      startIndex: startIndex,
      endIndex: endIndex,
      pages: pages,
    };
  }
}
